import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { Housing } from "src/app/core/endpoints/models/housing";
import { User } from "src/app/core/endpoints/models/user.model";
import { Service } from "src/app/core/endpoints/models/service";
import { Extra } from "src/app/core/endpoints/models/extra";

@Component({
	selector: "app-housing",
	templateUrl: "./housing.component.html",
	styleUrls: ["./housing.component.scss"],
})
export class HousingComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;
	@ViewChild("fileInput") fileInput: any;

	public schedules: any[] = [];
	public housings: Housing[] = [];
	public workers: User[] = [];
	public workersData: any = [];
	public users: User[] = [];
	public services: Service[] = [];
	public extras: Extra[] = [];
	public loading: boolean = false;
	public dialogHousing: boolean = false;
	public housingSelected: Housing;
	public mode: "edit" | "register" = "edit";

	loggedUser : any;

	form: FormGroup = this.fb.group({
		workers: [""],
		user_id: ["", Validators.required],
		title: ["", Validators.required],
		address: ["", Validators.required],
		size: [""],
		services: this.fb.array([]),
		extras: this.fb.array([]),
	});

	constructor(
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		private apiService: ApiService,
		private fb: FormBuilder,
		private authService: AuthenticationService,
	) {
		this.loggedUser = this.authService.getUser();
	}

	ngOnInit(): void {
		this.loadHousing();
		if (this.loggedUser.role_id == 1){
			this.loadUsers();
		}
		this.loadWorkers();
		this.loadServices();
		this.loadExtras();
	}
	
	getUser() {
		return AuthService.getDataUser();
	}

	/**
	 * Resetear formulario
	 */
	public resetForm() {
		this.form.reset();
	}
	/**
	 * Limpiar filtros de búsqueda
	 * @param table
	 */
	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}

	/**
	 * Mostrar modal de creación/edición de vivienda
	 * @param housing
	 */
	public showDialog(housing?: any) {
		this.mode = housing ? "edit" : "register";
		if (housing) {
			this.housingSelected = housing;
			this.form.patchValue(housing);
			
			const servicesArray = this.servicesArray;
			servicesArray.clear();

			const extrasArray = this.extrasArray;
			extrasArray.clear();

			if (housing.workers){
				var workers = [];
				housing.workers.forEach(element => {
					workers.push(element.user_id);
				});
				this.form.patchValue({
					workers: workers
				});
			}

			if (housing.services) {
				this.services.forEach(service => {
					const matchingService = housing?.services?.find(
						(hService: any) => hService.service_id === service.id
					);
					servicesArray.push(
						this.fb.group({
							id: [matchingService ? matchingService.service_id : service.id],
							quantity: [matchingService ? matchingService.quantity : service.quantity || 1],
							price: [matchingService ? matchingService.price : service.price || 0],
							active:   [ matchingService ? matchingService.status ? true : false : false ]
						})
					);
				});
			} else {
				this.form.reset();
				this.services.forEach(service => {
					servicesArray.push(
						this.fb.group({
							id: [service.id],
							price: [service.price || 0],
							quantity: [service.quantity ||1],
							active: [service.active || false],
						})
					);
				});
			}

			if (housing.extras){
				this.extras.forEach(extra => {
					const matchingExtra = housing?.extras?.find(
						(hExtra: any) => hExtra.extra_id === extra.id
					);
					extrasArray.push(
						this.fb.group({
							id: [matchingExtra ? matchingExtra.extra_id : extra.id],
							quantity: [matchingExtra ? matchingExtra.quantity : extra.quantity || 1],
							price: [matchingExtra ? matchingExtra.price : extra.price || 0],
							active:   [ matchingExtra ? matchingExtra.status ? true : false : false ]
						})
					);
				});
			}else{
				this.extras.forEach(extra => {
					extrasArray.push(
						this.fb.group({
							id: [extra.id],
							price: [extra.price || 0],
							quantity: [extra.quantity ||1],
							active: [extra.active || false],
						})
					);
				});
			}
		}else{
			this.form.reset();
			const servicesArray = this.servicesArray;
			servicesArray.clear();
			this.services.forEach(service => {
				servicesArray.push(
					this.fb.group({
						id: [service.id],
						price: [service.price || 0],
						quantity: [service.quantity ||1],
						active: [service.active || false],
					})
				);
			});
			const extrasArray = this.extrasArray;
				extrasArray.clear();
				this.extras.forEach(extra => {
					console.log(extra);
					extrasArray.push(
						this.fb.group({
							id: [extra.id],
							price: [extra.price || 0],
							quantity: [extra.quantity ||1],
							active: [extra.active || false],
						})
					);
				});
		}
		this.dialogHousing = true;
	}

	/**
	 * Cargar listado de viviendas
	 */
	public loadHousing() {
		this.loading = true;
		this.apiService.getEntity("housings").subscribe({
			next: (result) => {
				this.housings = result.housings;
				this.loading = false;
			},
			error: (err) => {
				console.log(err);
				this.loading = false;
				this.toast.show(
					"Error",
					"Ocurrió un error obteniendo el listado de viviendas, inténtelo de nuevo",
					"error"
				);
			},
			complete: () => {
				this.loading = false;
			},
		});
	}
	
	public loadWorkers() {
		this.loading = true;
		this.apiService.getEntity("users", 2).subscribe({
			next: (result) => {
				this.workers = result.users;
				this.workers.forEach(element => {
					this.workersData[element.id] = element;
				});
				this.workers = this.workers.map((user) => ({
					...user,
					role_id_string: user.role_id === 1 ? "Admin" : user.role_id === 2 ? "Trabajador": user.role_id === 3 ? "Facturación": "Usuario"
				}));
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	
	public loadUsers() {
		this.loading = true;
		this.apiService.getEntity("users", 4).subscribe({
			next: (result) => {
				this.users = result.users;
				this.users = this.users.map((user) => ({
					...user,
					role_id_string: user.role_id === 1 ? "Admin" : user.role_id === 2 ? "Trabajador": user.role_id === 3 ? "Facturación": "Usuario"
				}));
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	
	public loadServices() {
		this.loading = true;
		this.apiService.getEntity("services").subscribe({
			next: (result) => {
				this.services = result.services;
				const servicesArray = this.servicesArray;
				servicesArray.clear();
				this.services.forEach(service => {
					servicesArray.push(
						this.fb.group({
							id: [service.id],
							price: [service.price || 0],
							quantity: [service.quantity ||1],
							active: [service.active || false],
						})
					);
				});
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
			},
		});
	}
	
	public loadExtras() {
		this.loading = true;
		this.apiService.getEntity("extras").subscribe({
			next: (result) => {
				this.extras = result.extras;
				const extrasArray = this.extrasArray;
				extrasArray.clear();
				this.extras.forEach(extra => {
					extrasArray.push(
						this.fb.group({
							id: [extra.id],
							price: [extra.price || 0],
							quantity: [extra.quantity ||1],
							active: [extra.active || false],
						})
					);
				});
				this.loading = false;
			},
			error: (err) => {
				this.loading = false;
			},
		});
	}



	/**
	 * Enviar formulario de registro/edición de vivienda
	 */
	public async registerHousing() {
		this.form.markAllAsTouched();

		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return this.toast.show("Aviso", "Revise el formulario", "warn");
		}

		const formValue = this.form.value;
		const formData = new FormData();

		formData.append("workers", formValue.workers ? formValue.workers : '');
		formData.append("user_id", formValue.user_id);
		formData.append("title", formValue.title.toString());
		formData.append("size", formValue.size ? formValue.size : null);
		formData.append("address", formValue.address.toString());

		const servicesArray = this.servicesArray.value;
		servicesArray.forEach((service: any, index: number) => {
			if (service.id == null){
				service.id = this.services[index]?.id;
			}
			formData.append(`services[${index}][id]`, this.services[index]?.id || service.id);
			formData.append(`services[${index}][price]`, service.price);
			formData.append(`services[${index}][quantity]`, service.quantity);
			formData.append(`services[${index}][active]`,   service.active ? '1' : '0');
		});
		
		const extrasArray = this.extrasArray.value;
		extrasArray.forEach((extra: any, index: number) => {
			if (extra.id == null){
				extra.id = this.extras[index]?.id;
			}
			formData.append(`extras[${index}][id]`, this.extras[index]?.id || extra.id);
			formData.append(`extras[${index}][price]`, extra.price);
			formData.append(`extras[${index}][quantity]`, extra.quantity);
			formData.append(`extras[${index}][active]`,   extra.active ? '1' : '0');
		});
		
		this.loading = true;

		if (this.mode === "register") {
			this.apiService.addEntityFormData("registerHousing", formData).subscribe({
				next: (result) => {
					this.toast.show("Vivienda registrada correctamente");
					this.loading = false;
					this.dialogHousing = false;
					this.loadHousing();
				},
				error: (err) => {
					var error = "Ocurrió un error al registrar la vivienda, inténtelo de nuevo";
					if (err.error.message){
						error = err.error.message;
					}
					this.loading = false;
					this.toast.show(
						"Error",
						error,
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		} else {
			formData.append("id", this.housingSelected.id.toString());
			this.apiService.addEntityFormData("updateHousing", formData).subscribe({
				next: (result) => {
					this.toast.show("Vivienda actualizada correctamente");
					this.loading = false;
					this.dialogHousing = false;
					this.loadHousing();
				},
				error: (err) => {
					var error = "Ocurrió un error al registrar la vivienda, inténtelo de nuevo";
					if (err.error.message){
						error = err.error.message;
					}
					this.loading = false;
					this.toast.show(
						"Error",
						error,
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		}
	}

	/**
	 * Eliminar vivienda seleccionado
	 */
	public deleteHousing(housing: Housing) {
		if (this.loading) return;
		this.confirmationService.confirm({
			header: 'Eliminar vivienda',
			message: "¿Está seguro que desea eliminar esta vivienda?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.deleteEntity("deleteHousing", housing.id).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Vivienda eliminada correctamente");
						this.loadHousing();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Aviso",
							"Ocurrió un error intentando eliminar la vivienda, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}

	get servicesArray(): FormArray {
		return this.form.get('services') as FormArray;
	}

	get extrasArray(): FormArray {
		return this.form.get('extras') as FormArray;
	}
	
	getServiceControl(index: number, controlName: string): FormControl {
		return this.servicesArray.at(index).get(controlName) as FormControl;
	}

	getExtraControl(index: number, controlName: string): FormControl {
		return this.extrasArray.at(index).get(controlName) as FormControl;
	}
}
